// extracted by mini-css-extract-plugin
export var quillEditor = "_r0-1";
export var variable = "_r0-0";